import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { settingsTypes } from '@/configuration/constants'
import configurationServices from '@/configuration/services/services'

const useSettingsType = ({ returnPortalId, section, isUnifiedDashboard, setToastInfo }) => {
  const [settingsType, setSettingsType] = useState('')
  const [hasChanges, setHasChanges] = useState(false)
  const { t } = useTranslation()

  const { data: storeSettingsType, loading: loadingStoreSettingsType } = useFetch(
    () => configurationServices.getPortalSettingsType({ returnPortalId }),
    {
      doInitialRequest: !isUnifiedDashboard,
    }
  )

  const { fetchData: saveStoreSettingsType, loading: savingStoreSettingsType } = useFetch(
    configurationServices.editPortalSettingsType,
    {
      doInitialRequest: false,
    }
  )

  const setInitialSettingsType = useCallback(() => {
    if (storeSettingsType && section) {
      setSettingsType(storeSettingsType?.[section] || settingsTypes.custom)
      setHasChanges(false)
    }
  }, [storeSettingsType, section])

  useEffect(() => {
    setInitialSettingsType()
  }, [setInitialSettingsType])

  const revertSettingsType = () => {
    setInitialSettingsType()
  }

  const onSaveSettingsType = async () => {
    try {
      await saveStoreSettingsType({
        returnPortalId,
        params: {
          [section]: settingsType,
        },
      })
      setHasChanges(false)
      setToastInfo({ show: true, message: t('Configuración global aplicada correctamente'), type: 'success' })
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    settingsType,
    setSettingsType: params => {
      setSettingsType(params)
      setHasChanges(true)
    },
    saveStoreSettingsType,
    loadingStoreSettingsType,
    savingStoreSettingsType,
    onSaveSettingsType,
    revertSettingsType,
    hasChanges,
  }
}

export default useSettingsType
